<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountList' }">合作产品路径</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="copy">复制</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'partner_product_account' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['account', 'product', 'partner'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="期间信息" name="2">
                    <vPartnerProductAccountPeriodComponent v-if="flag" :postList="postList"></vPartnerProductAccountPeriodComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="初始化信息" name="3">
                    <vCommodityFlowStateInitComponent v-if="flag" :postList="postList"></vCommodityFlowStateInitComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vCommodityFlowStateInitComponent from '../../listComponent/basicdata/commodityFlowStateInit/commodityFlowStateInitComponent.vue';
import vPartnerProductAccountPeriodComponent from '../../listComponent/basicdata/partnerProductAccountPeriod/partnerProductAccountPeriodComponent.vue';
export default {
    inject: ['reload'],
    name: 'partnerProductAccountDetail',
    components: {
        draggableDetail,
        vCommodityFlowStateInitComponent,
        vPartnerProductAccountPeriodComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2','3'],
            data: {},
            queryParams: {},
            headerTitle: '合作产品路径详情',
            flag: false,
            postList: {
                headerTitle: false,
                addBtn: true,
                setBtn: true,
                params: {
                    ppa_rid: ''
                }
            }
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.postList.params.ppa_rid = this.$route.query.id;
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (prop == 'account' && this.data.account_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.account_rid
                    }
                });
            } else if (prop == 'product' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'partner' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).partner_product_account;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .partnerProductAccountDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'partnerProductAccountDelete', this.data.code, 'partnerProductAccountList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>